export const checkVehicleMatchesLeaseDeal = ({ deal, vehicle }) =>
  deal.makeNiceName === vehicle.makeSlug && deal.modelNiceName === vehicle.modelSlug && deal.year === vehicle.year;

export const checkSomeVehicleHaveLeaseDeal = ({ vehicles, leaseDeals }) =>
  !!leaseDeals?.deals?.find(deal => vehicles.some(vehicle => checkVehicleMatchesLeaseDeal({ vehicle, deal })));
